import {
  Address,
  addressToMultilineAddress,
  addressToString,
  isUndefined,
  PropertyIdentification,
} from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectEditablePropertyDataEntities } from './editablePropertyDataSelectors.ts';

export const selectPropertyIdentificationEntities = createSelector(
  [selectEditablePropertyDataEntities],
  (editablePropertyDataEntities) => {
    const entities = Object.fromEntries(
      Object.entries(editablePropertyDataEntities).map(([id, editableData]) => [
        id,
        { id, ...editableData.propertyIdentification },
      ]),
    );

    // Add a separate entry for subjectArv if it exists in editablePropertyDataEntities
    // The content should be the same as the subject propertyIdentification
    if (entities.subject && editablePropertyDataEntities.subject && 'arv' in editablePropertyDataEntities.subject && editablePropertyDataEntities.subject.arv) {
      entities.subjectArv = { ...entities.subject };
    }

    return entities;
  },
);

export const selectPropertyIdentificationById = createSelector(
  [selectPropertyIdentificationEntities, (_state, id: string) => id],
  (propertyIdentificationEntities, id) => propertyIdentificationEntities[id],
);

export const selectAllPropertyIdentification = createSelector(
  [selectPropertyIdentificationEntities],
  (propertyIdentificationEntities) => {
    const values = Object.values(propertyIdentificationEntities);
    const entities: (PropertyIdentification & { id: string })[] = [];
    values.forEach((value) => {
      if (!entities.find((entity) => entity.id === value.id)) {
        entities.push(value);
      }
    });
    return entities;
  },
);

export const selectAddress = createSelector(
  [selectPropertyIdentificationEntities, (_state, id: string) => id],
  (propertyIdentificationEntities, id): Address => {
    const propertyIdentification = propertyIdentificationEntities[id];

    if (isUndefined(propertyIdentification) || isUndefined(propertyIdentification.address))
      return {};

    return propertyIdentification.address;
  },
);

export const selectMultilineAddress = createSelector([selectAddress], (address) =>
  addressToMultilineAddress(address),
);

export const selectSubjectAddress = createSelector(
  [selectPropertyIdentificationEntities],
  (propertyIdentification): string => {
    const subjectPropertyIdentification = propertyIdentification.subject;
    if (
      isUndefined(subjectPropertyIdentification) ||
      isUndefined(subjectPropertyIdentification.address)
    )
      return '';

    return addressToString(subjectPropertyIdentification.address);
  },
);
